import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild, ViewEncapsulation, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import icVisibility from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';
import { fadeInUp400ms } from 'src/@core/animations/fade-in-up.animation';
import { LoginResponse } from 'src/@core/interfaces/login-response.model';
import { AuthService } from 'src/@core/services/auth.service';
import { AppService } from 'src/@core/services/app.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { MatDialog } from '@angular/material';
import { first, map } from 'rxjs/operators';
import { MessageConstant } from 'src/app/shared/helpers/message.constant';
import { AccountService } from 'src/@core/services/account.service';
import { EmployerService } from 'src/@core/services/employer/employer.service';
import { Employer } from 'src/@core/interfaces/employer/employer.model';
import { LocalStorageService } from 'src/@core/services/local-storage.service';
import { ThemeService } from 'src/@core/services/theme.service';
import { ConfigService } from 'src/@core/services/theme/config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_AUTH } from 'src/@core/services/util/api.endpoints';
import { gapi } from 'gapi-script';
import { environment } from 'src/environments/environment';
import { isAssignedLeadsOnlyAccount, MY_LEADS_ROUTE } from 'src/app/shared/helpers/roles-permissions';

@Component({
  selector: 'hour4u-admin-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
  // styles: [
  //   `
  //   :host >>> .swiper-pagination-bullet-active {
  //     background: white;
  //   }
  //   `
  // ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fadeInUp400ms
  ]
})
export class LoginComponent implements OnInit {
  @ViewChild('leftSection', { static: true }) leftSection: ElementRef<HTMLDivElement>;
  @ViewChild('rightSection', { static: true }) rightSection: ElementRef<HTMLDivElement>;
  slideIndex = 1;
  xDown: number; // Property to store initial touch position

  loading = false;
  model: any = {};
  loginStatus: string = null;
  user: LoginResponse;
  form: FormGroup;
  isLoading = false;

  inputType = 'password';
  visible = false;

  icVisibility = icVisibility;
  icVisibilityOff = icVisibilityOff;
  isLoggingIn: boolean = false;
  isSignupUsingOTP: boolean = false;

  public slidesArray: any = [
    {
      image: 'assets/login-slide-1.svg',
      headerHeading: 'Meet our digital workers',
      headerText: 'Digital workers that talk to customers on calls and WhatsApp, remember past conversations, and work until your goals are achieved.',
      subText: '',
    },
    // {
    //   image: 'assets/login-slide-1.svg',
    //   headerHeading: 'Meet our digital workers',
    //   headerText: 'Digital workers automate tasks and transform your business. With 24/7 operations and human-like intelligence, they revolutionize work.',
    //   subText: '',
    // },
    // {
    //   image: 'assets/login-slide-1.svg',
    //   headerHeading: 'Meet our digital workers',
    //   headerText: 'Digital workers automate tasks and transform your business. With 24/7 operations and human-like intelligence, they revolutionize work.',
    //   subText: '',
    // }
  ];
  isSignup: boolean = false;
  selectedOption: string = "PASSWORD";
  showOTPInput: boolean = false;
  showCompanyDetailsScreen: boolean = false;
  hideEmailInput: boolean = false;
  hideMobileInput: boolean = false;
  showNextStep: number = 1;
  showWaitingList: boolean = false;
  redirectURL: string;
  CLIENT_ID: string = environment.googleClientId;
  googleScope: string = environment.googleScope;
  @ViewChild('emailInput', { static: true }) emailInput: ElementRef;
  imageUrl$: any = this.configService.config$.pipe(map(config => config.sidenav.imageUrl));
  showLoader: boolean = false;
  referralCode: string | null = null;
  entityType: string | null = null;
  profile = this.app.getCurrentAccount();
  showSignupBtn: boolean = false;
  showSigninBtn: boolean = false;

  constructor(private authService: AuthService,
    private router: Router,
    private app: AppService,
    private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    private notify: NotificationService,
    private accountService: AccountService,
    private dialog: MatDialog,
    private employerService: EmployerService,
    private _localStorageService: LocalStorageService,
    private route: ActivatedRoute,
    public cdr: ChangeDetectorRef,
    public themeService: ThemeService,
    private configService: ConfigService,
    private http: HttpClient,
    private cdRef: ChangeDetectorRef,
    private ngZone: NgZone) {

    if (this.app.getCurrentAccount() != null && this.app.getCurrentAccount().user) {
      console.log("Logged in hai");
      if (this.profile.entity.onboardingJourneyCompleted && this.profile.entity.onboardingTyp !== "WAITLIST") {
        this.router.navigateByUrl('/dashboard')
      } else {
        // Mutual exclusion: showCompanyDetailsScreen and showWaitingList must
        // never both render — the two full-screen branches stack otherwise.
        this.showCompanyDetailsScreen = true;
        this.showWaitingList = false;
      }
    } else {
      console.log("Logged in nahi hai")
    }
    this.authService.isNewUserSignUp = false;
    //Employer signup
    //this.empSignup();
  }

  ngOnInit() {
    const restrictedDomains = new Set([
      // "gmail.com", "yahoo.com", "outlook.com", "hotmail.com",
      // "aol.com", "icloud.com", "protonmail.com"
    ]);
    this.form = this.fb.group({
      email: ['', [
        Validators.required,
        this.emailOrPhoneValidator,
        (control: AbstractControl): { [key: string]: boolean } | null => {
          const email = control.value;
          if (email && email.includes('@')) {
            const domain = email.split('@')[1];
            if (restrictedDomains.has(domain)) {
              return { restrictedDomain: true };
            }
          }
          return null;
        }
      ]],
      password: ['', Validators.required],
      mobile: ['', [Validators.pattern(/^[6-9]\d{9}$/)]],
      name: [''],
      companyName: [''],
      gstNumber: [''],
      address: [''],
      referralCode: ['']
    });
    // Pre-fill form if profile exists
    if (this.profile && this.profile.entity) {
      const name = this.profile.user && this.profile.user.userMeta ? this.profile.user.userMeta.name : '';
      const companyName = this.profile.entity && this.profile.entity.entityMeta ? this.profile.entity.entityMeta.name : '';
      const mobile = this.profile.entity ? this.profile.entity.mobile : '';
      this.form.patchValue({
        name: name,
        companyName: companyName,
        mobile: mobile
      });
    }
    this.initClientGoogle();
    this.getStarted();
    this.selectedOption = 'OTP'
    // Using queryParamMap (preferred way)
    this.route.queryParams.subscribe((params) => {
      console.log(params);
      if (params && Object.keys(params).length > 0) {
        this.referralCode = params['referralCode'];
        this.showSignupBtn = false;
        if (this.referralCode) {
          this.form.patchValue({ referralCode: this.referralCode });
        }
        this.entityType = params['entityType'];
        console.log('Referral Code:', this.referralCode);
        console.log('Entity Type:', this.entityType);
        this.selectedOption = 'OTP';
        this.isSignup = true;
        // Add domain restriction validator for referral-based signup
        const restrictedDomains = new Set([
          // "gmail.com", "yahoo.com", "outlook.com", "hotmail.com",
          // "aol.com", "icloud.com", "protonmail.com"
        ]);
        if (this.referralCode) {
          this.form.controls['email'].setValidators([
            Validators.required,
            this.emailOrPhoneValidator,
            (control: AbstractControl): { [key: string]: boolean } | null => {
              const email = control.value;
              if (email && email.includes('@')) {
                const domain = email.split('@')[1];
                if (restrictedDomains.has(domain)) {
                  return { restrictedDomain: true };
                }
              }
              return null;
            }
          ]);
          this.form.controls['email'].updateValueAndValidity();
        }
        //this.showOTPInput = true;
      }
    });
    //this.changeAuthOption()
  }


  getRedirectURL(): string {
    // An RM has one screen; landing them on the dashboard would only bounce.
    if (isAssignedLeadsOnlyAccount(this.app.getCurrentAccount())) {
      return MY_LEADS_ROUTE;
    }
    return this.redirectURL ? this.redirectURL : '/dashboard';
  }

  initClientGoogle() {
    gapi.load('client:auth2', () => {
      gapi.auth2
        .init({
          client_id: this.CLIENT_ID,
          cookiepolicy: 'single_host_origin',
          scope: this.googleScope,
          access_type: 'offline',
        })
        .then(() => {
          console.log('Google API client initialized');
        })
        .catch((error) => {
          console.error('Error initializing Google API client:', error);
        });
    });
  };


  ngAfterViewInit() {
    if (this.emailInput && this.emailInput.nativeElement) {
      this.emailInput.nativeElement.style.setProperty('--placeholder-color', 'white');
      setTimeout(() => {
        this.cdRef.detectChanges();
      });
    }
  }

  emailOrPhoneValidator(control: AbstractControl): { [key: string]: any; } | null {
    const value = control.value;
    console.log(value);
    if (!value) {
      return null; // let required validator handle empty values
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const phonePattern = /^\d{10}$/; // Adjust the phone pattern as needed

    const isValidEmail = emailPattern.test(value);
    const isValidPhone = phonePattern.test(value);

    if (!isValidEmail && !isValidPhone) {
      return { invalidEmailOrPhone: true };
    }
    return null;
  }

  onlyNumberKey(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  toggleVisibility() {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = 'text';
      this.visible = true;
      this.cd.markForCheck();
    }
  }

  signIn() {
    if (this.isLoggingIn) {
      return;
    }

    if (!this.form.valid) {
      console.log(this.form)
      this.form.markAllAsTouched();
      return;
    } else {
      if (!this.isSignup) {
        this.loginStatus = 'progress';
        this.isLoading = true;
        this.isLoggingIn = true;

        this.authService.loginEnterprise(this.selectedOption, this.form.value.email, this.form.value.password)
          .pipe(first())
          .subscribe(async (data: any) => {
            console.log(data);
            this.isLoading = false;
            this.isLoggingIn = false;
            if (data && data.entity) {
              if (!data.entity.onboardingJourneyCompleted) {
                this.showCompanyDetails();
              } else {
                await this.setUserData(data);
              }
            }
            setTimeout(() => {
              this.cdRef.detectChanges();
            });
          },
            error => {
              this.isLoading = false;
              this.isLoggingIn = false;
              this.cd.detectChanges();
            });
      } else {
        this.isLoading = true;
        this.isLoggingIn = true;

        let param = null;
        if (this.referralCode) {
          param = {
            "referralCode": this.referralCode,
            "entityType": this.entityType
          }
        }

        this.authService.loginEnterprise(this.selectedOption, this.form.value.email, this.form.value.password, param)
          .pipe(first())
          .subscribe(async (data: any) => {
            console.log(data);
            // await this.setUserData(data);
            this.isLoading = false;
            this.isLoggingIn = false;
            if (data && data.entity) {
              if (!data.entity.onboardingJourneyCompleted) {
                this.showCompanyDetails();
              } else {
                await this.setUserData(data);
              }
            }
            setTimeout(() => {
              this.cdRef.detectChanges();
            });
          },
            error => {
              this.isLoading = false;
              this.isLoggingIn = false;
              this.cd.detectChanges();
            });
      }
    }
  }

  explorePlatform() {
    this.isLoading = true;
    this.isLoggingIn = true;

    const nameCtrl = this.form.controls['name'];
    const companyCtrl = this.form.controls['companyName'];
    const referralCtrl = this.form.controls['referralCode'];
    const mobileCtrl = this.form.controls['mobile'];

    nameCtrl.setValidators([Validators.required]);
    companyCtrl.setValidators([Validators.required]);
    nameCtrl.updateValueAndValidity();
    companyCtrl.updateValueAndValidity();

    const name = nameCtrl.value.trim();
    const companyName = companyCtrl.value.trim();
    const enteredReferral = referralCtrl && referralCtrl.value ? referralCtrl.value.trim() : null;
    const enteredMobile = mobileCtrl && mobileCtrl.value ? mobileCtrl.value.trim() : null;
    this.referralCode = enteredReferral || this.referralCode;
    console.log("explore platform clicked")

    if (companyName && name) {
      console.log("moved ahead with companyName && name")

      const user = this.app.getCurrentAccount();

      let obj = {
        "entityId": user.entity.id,
        "userId": user.user.id,
        "entityName": companyName,
        "userName": name,
        "referralCode": this.referralCode,
        "mobile": enteredMobile
      };

      this.authService.updateUserProfile(obj).subscribe((data: any) => {
        if (data.entity && data.entity.onboardingType === 'WAITLIST') {
          this.showWaitingList = true;
          this.showCompanyDetailsScreen = false;
          this.isLoading = false;
          this.isLoggingIn = false;
          this.cd.detectChanges();
          return;
        } else {
          let userData = data.entityUserMapping[0];
          userData.user = data.user;
          userData.roles = [];
          userData.permissions = [];

          if (userData.role) {
            userData.roles.push(userData.role.roleName);
            userData.permissions.push(userData.role.permissions);
          }

          this.app.setCurrentAccount(userData);
          this.authService.isNewUserSignUp = true;
          this.setUserData(userData);
          this.isLoading = false;
          this.isLoggingIn = false;
          this.loading = false;
          this._localStorageService.setIsFirstTimeLogin(true);
        }
      }, (err => {
        this.form.controls['referralCode'].setValue('');
        this.referralCode = null;
        this.isLoading = false;
        this.isLoggingIn = false;
        this.cd.detectChanges();
        this.isLoading = false;
        this.isLoggingIn = false;
        this.loading = false;
      }));
    } else {
      this.isLoading = false;
      this.isLoggingIn = false;
      this.loading = false;
    }
  }

  empSignup() {
    this.router.navigate(['/employer-signup'], {
      queryParams: {
        pageStatus: 'setup'
      }
    });
  }

  async setUserData(data) {
    // await this.accountService.getById(accountId).toPromise()
    //   .then(async data => {
    //     const user = this.app.getCurrentAccount();
    //     user.user_details = data;
    // this.app.setCurrentAccount(data);
    //     if (data.employerId != null) {
    //       this.app.setIsEmployerLogin(true);
    //       await this.loadEmployerInfo(data.employerId);
    //     }
    //   }).then(data => {
    //     this.loginStatus = null;
    if (data.entity && data.entity.onboardingType === 'WAITLIST') {
      this.showWaitingList = true;
      this.showCompanyDetailsScreen = false;
      this.cdRef.detectChanges();
      return;
    }

    this.redirectNow();
    // });
  }


  async loadEmployerInfo(id: string) {
    await this.employerService.getById(id).toPromise()
      .then((employer: Employer) => {
        if (employer) {
          this.app.setEmployer(employer);
        }
      }).catch(error => {
        this.notify.showMessage('Something went wrong with your details, try again after sometime...', 3000);
        this.app.logout();
      });
  }

  redirectNow() {
    const user = this.app.getCurrentAccount();
    console.log(user);
    // if (user.role.roleName.includes('JOB_SUPERVISOR')) {
    //   this.router.navigate(['/supervisor-admin']);
    // } else if (user.role.roleName.includes('PERMISSION_USER')) {
    //   this.router.navigate(['/societies']);
    // } else {
    this.ngZone.run(() => {
      this.router.navigateByUrl(this.getRedirectURL());
    });
    // }
  }
  getStarted() {
    // if (this.leftSection) {
    //   const leftSectionElement: HTMLElement = this.leftSection.nativeElement;
    //   leftSectionElement.style.display = 'none';
    // } else {
    //   console.error('Left section element not found.');
    // }

    if (this.rightSection) {
      const rightSectionElement: HTMLElement = this.rightSection.nativeElement;
      rightSectionElement.style.display = 'flex';
    } else {
      console.error('Right section element not found.');
    }
  }

  requestDemo() {
    window.open('https://calendly.com/workorbits/demo', '_blank');
  }

  signUp() {
    this.isSignup = true;
    this.form.reset();
    this.selectedOption = "OTP";
    this.isSignupUsingOTP = true;
  }

  getOTP() {
    this.showOTPInput = false;
    this.showSignupBtn = false;
    this.showSigninBtn = false;
    this.isLoading = true;
    if (this.form.value.email) {
      let obj = {
        "userName": this.form.value.email,
        "userNameType": this.form.value.email.includes('@') ? 'EMAIL' : 'MOBILE',
      };
      this.authService.sendForgotOTPLink(obj).subscribe(data => {
        console.log(data)
        // if (data.newEntity == true) {
        //   this.showWaitingList = true;
        //   this.isLoading = false;
        //   this.cdr.detectChanges();
        // } else {
        this.showNextStep = 1;
        this.showOTPInput = true;
        this.showSignupBtn = true;
        this.showSigninBtn = true;
        this.isLoading = false;
        this.cd.detectChanges();
        this.notify.showMessage('OTP sent successfully!', 3000);
        // }
      }, (error) => {
        this.showOTPInput = false;
        this.showSignupBtn = false;
        this.showSigninBtn = false;
        this.isLoading = false;
        this.cd.detectChanges();
        this.notify.showMessage('User does not exists !', 3000);
      });
    } else {
      this.notify.showMessage('Please enter valid email !', 3000);
    }
  }

  onOtpChange(otp: string) {
    // OTP value is automatically set via formControlName
    // This method can be used for additional logic if needed
  }

  changeAuthOption() {
    this.showOTPInput = false;
    this.form.controls['password'].setValue('');
    this.form.controls['password'].updateValueAndValidity();
    if (this.selectedOption == 'OTP') {
      this.selectedOption = 'PASSWORD';
      return;
    }
    if (this.selectedOption == 'PASSWORD') {
      this.selectedOption = 'OTP';
      return;
    }
  }

  backToLogin() {
    console.log("Back to login called");
    this.isSignup = false;
    this.form.reset();
    this.selectedOption = "OTP";
    this.isSignupUsingOTP = false;
  }

  continue() {
  }

  changeTheme(event: any) {
    this.themeService.isDarkTheme = event.checked;
    this.themeService.toggleTheme();
    let imageUrl = "";
    if (this.themeService.isDarkTheme) {
      imageUrl = "assets/house-of-agents.svg";
    } else {
      imageUrl = "assets/house-of-agents-black.svg";
    }
    this.configService.updateConfig({
      sidenav: {
        imageUrl: imageUrl
      }
    });
    this.cd.detectChanges();
  }

  signInWithGoogle(): void {
    const authInstance = gapi.auth2.getAuthInstance();

    authInstance.grantOfflineAccess({ prompt: 'consent' }).then(response => {

      const authCode = response.code;

      this.http.post<{ idToken: string, refreshToken: string, user: any }>(
        API_AUTH + '/v1/google/exchange-token',
        { code: authCode }
      ).subscribe({
        next: (response) => {
          const idToken = response.idToken;
          const refreshToken = response.refreshToken;

          this.http.post(API_AUTH + '/v1/google/verify/token', { token: idToken, referralCode: this.referralCode, entityType: this.entityType })
            .pipe(map((user: any) => {
              let userData = user.entityUserMapping[0];
              userData.user = user.user;
              userData.roles = [userData.role.roleName];
              userData.permissions = [userData.role.permissions];
              this.app.setCurrentAccount(userData);
              return { userData, refreshToken };
            }))
            .subscribe({
              next: ({ userData, refreshToken }) => {
                console.log("userData----", userData)
                this.showLoader = true;
                this.cd.detectChanges();

                if (refreshToken) {
                  this.saveRefreshToken(userData.user.id, userData.user.email, refreshToken);
                }

                if (userData && userData.entity) {
                  this.showLoader = false;
                  this.cdRef.detectChanges();
                  if (!userData.entity.onboardingJourneyCompleted) {
                    this.showCompanyDetails();
                  } else {
                    this.setUserData(userData);
                  }
                }
                // this.setUserData(userData);

                // setTimeout(() => {
                //   this.showLoader = false;
                //   this.router.navigateByUrl(this.getRedirectURL());
                // }, 1000);
              },
              error: (err) => {
                console.error("ID Token Verification Failed:", err);
                this.showLoader = false;
                this.cd.detectChanges();
              }
            });
        },
        error: (err) => {
          this.showLoader = false;
          this.cd.detectChanges();
          console.error("Token Exchange Failed:", err);
        }
      });
    }).catch(err => {
      this.showLoader = false;
      this.cd.detectChanges();
      console.error("Google sign-in failed:", err);
    });
  }

  saveRefreshToken(userId: string, email: string, refreshToken: string): void {
    const userTokenDto = { userId, email, googleRefreshToken: refreshToken };
    const authToken = localStorage.getItem("jwtToken");

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    });

    this.http.post(API_AUTH + '/v1/user-tokens/save', userTokenDto, { headers })
      .subscribe({
        next: () => console.log("Refresh token stored successfully!"),
        error: (err) => console.error("Failed to store refresh token:", err)
      });
  }

  showCompanyDetails() {
    this.showCompanyDetailsScreen = true;
    this.form.controls['name'].setValidators([Validators.required]);
    this.form.controls['companyName'].setValidators([Validators.required]);
    this.form.controls['name'].updateValueAndValidity();
    this.form.controls['companyName'].updateValueAndValidity();
    this.cdRef.detectChanges();
  }
  logout() {
    console.log("logout clicked")
    this.app.logout();
    this.showCompanyDetailsScreen = false;
    this.isSignup = false;
    this.form.reset();
    this.selectedOption = "OTP";
    this.isSignupUsingOTP = false;
    this.showWaitingList = false;
  }
  redirectToDemo() {
    window.open('https://calendly.com/hello-houseofagents/30min', '_blank');
  }
}
